
class BookingPaymentMethodDisagioSelectors {

    getCheckbox(element)
    {

        return '.booking_payment_method_disagio_checkbox';
    }



}

